import { http, createConfig } from 'wagmi'
import { bscTestnet } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'
import { isMobileDevice } from './utils/authHelpers'

const projectId = '5d8afb2d4d7f105beb4757e829ac224c'

// Configuración de metadatos para WalletConnect
const metadata = {
  name: 'Plataforma12',
  description: 'Plataforma de streaming con tecnología blockchain',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://testproyect100new.com',
  icons: [typeof window !== 'undefined' ? `${window.location.origin}/img/logo.png` : '/img/logo.png']
}

// Crear configuración adaptada a dispositivos móviles
export const config = createConfig({
  chains: [bscTestnet],
  connectors: [
    injected({
      shimDisconnect: true, // Mejora la experiencia de desconexión
    }),
    walletConnect({
      projectId,
      metadata,
      showQrModal: true,
      // Opciones optimizadas para móviles
      qrModalOptions: {
        themeMode: 'dark',
        themeVariables: {
          '--w3m-z-index': '9999', // Asegurar que el modal esté por encima de todo
          '--w3m-background-color': '#1a1a1a', 
          '--w3m-accent-color': '#45c0be', // Color de acento coincidente con el tema
        },
        // Opciones adicionales para móviles
        mobileLinks: [
          'metamask',
          'rainbow',
          'trust',
          'ledger',
          'coinbase',
        ],
      },
    }),
  ],
  // No usar autoConnect para evitar problemas de conexión en móviles
  autoConnect: false,
  // Mejorar la configuración de transporte para incluir fallbacks
  transports: {
    [bscTestnet.id]: http("https://bsc-testnet-rpc.publicnode.com", {
      batch: {
        // Limitar el tamaño del lote para evitar problemas con algunos RPC
        multicall: {
          batchSize: 1024 * 50, // 50KB es un tamaño seguro para la mayoría de RPC
          wait: 0, // No esperar, enviar inmediatamente
        },
      },
      // Configurar timeouts más largos para dispositivos móviles
      fetchOptions: {
        timeout: isMobileDevice() ? 20000 : 10000, // 20s para móviles, 10s para desktop
      },
      // Reintentar solicitudes fallidas
      retryCount: 3,
      retryDelay: 1000,
    }),
  },
});